import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ViewerLogin() {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/viewer/login`, form);
      const token = res.data.token;
      if (token) {
        localStorage.setItem('viewer_token', token);
        toast({ title: 'Login realizado', description: 'Acesso às inscrições liberado.' });
        navigate('/viewer');
      }
    } catch (err) {
      toast({ title: 'Erro', description: err.response?.data?.detail || 'Credenciais inválidas', variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="bg-card border-2 border-border p-8 rounded-lg">
          <h1 className="text-2xl font-heading font-black tracking-tight uppercase text-primary text-center mb-6">Acesso de Acompanhamento</h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="username" className="text-sm font-bold uppercase tracking-widest text-primary mb-2">Usuário</Label>
              <Input id="username" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} required />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm font-bold uppercase tracking-widest text-primary mb-2">Senha</Label>
              <Input id="password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
            </div>
            <Button type="submit" className="w-full bg-primary text-primary-foreground" disabled={loading}>{loading ? 'Entrando...' : 'Entrar'}</Button>
          </form>
        </div>
      </div>
    </div>
  );
}
